export default __webpack_public_path__ + "static/media/planet-5570055.8f10d7bd.jpg";